const module = { name: 'movie/shared/mobile/videoLinksUI', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


const Selectors = {
    VIDEO_LINK: '.js-movie-video-link',
}
function trackVideoClick() {
    track(EventTypes.VIDEO_START);
}
function attach() {
    const videos = document.querySelectorAll(Selectors.VIDEO_LINK);
    if (!videos.length) {
        return;
    }
    videos.forEach(video => video.addEventListener('click', trackVideoClick));
}
module.exports = {
    attach
};
export default module.exports;